import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { BillingCycleRes } from '../rtm_plan/index.type';

export interface IState{
key:string,
value:string
}

const useTimeZone = () => {
    const [timeZone, setTimeZone] = React.useState<IState[]>([]);

    
    const { loading:timeZoneLoading, makeApiCall } = useApi({
      url: `/rtm/plan/timezone`,
      method: 'GET',
    });
  
    const getTimeZone= async () => {
      const { response, error } = await makeApiCall<undefined, BillingCycleRes>();
      
      if (response?.status === 'success') {
      
       setTimeZone(response.data);
        
      }
  
      if (error) toast.error('Something went wrong while billing cycle. Please try again later');
      return [];
    };
  
    return {
     timeZone,
    getTimeZone,
    timeZoneLoading,
    };
  };
  
export default useTimeZone;